import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCComercialAgentComponent = class UiCComercialAgentComponent {
    constructor() {
        this.onChange = new EventEmitter();
        this.DECIMAL_SEPARATOR = ".";
        this.GROUP_SEPARATOR = ",";
        this.cpfAgent = '';
    }
    ngOnInit() { }
    format(valString) {
        if (!valString) {
            return '';
        }
        let val = valString.toString();
        const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
        this.pureResult = parts;
        if (parts[0].length <= 11) {
            this.maskedId = this.cpf_mask(parts[0]);
            return this.maskedId;
        }
        else {
            this.maskedId = this.cnpj(parts[0]);
            return this.maskedId;
        }
    }
    ;
    unFormat(val) {
        if (!val) {
            return '';
        }
        val = val.replace(/\D/g, '');
        if (this.GROUP_SEPARATOR === ',') {
            return val.replace(/,/g, '');
        }
        else {
            return val.replace(/\./g, '');
        }
    }
    ;
    cpf_mask(v) {
        v = v.replace(/\D/g, ''); //Removes everything that is not digit
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Place a period between the third and fourth digits
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Place a period between the third and fourth digits
        //again (for the second block of numbers)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Place a hyphen between the third and fourth digits
        return v;
    }
    cnpj(v) {
        v = v.replace(/\D/g, ''); //Removes everything that is not digit
        v = v.replace(/^(\d{2})(\d)/, '$1.$2'); //Place a period between the second and third digits
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3'); //Place a period between the fifth and sixth digits
        v = v.replace(/\.(\d{3})(\d)/, '.$1/$2'); //Place a slash between the eighth and ninth digits
        v = v.replace(/(\d{4})(\d)/, '$1-$2'); //Put a hyphen after the four-digit block
        return v;
    }
    onChangeForm() {
        this.onChange.emit(this.formComercialAgent);
    }
};
__decorate([
    Input()
], UiCComercialAgentComponent.prototype, "formComercialAgent", void 0);
__decorate([
    Input()
], UiCComercialAgentComponent.prototype, "errorMessages", void 0);
__decorate([
    Output()
], UiCComercialAgentComponent.prototype, "onChange", void 0);
UiCComercialAgentComponent = __decorate([
    Component({
        selector: 'ui-c-comercial-agent',
        template: "<form [formGroup]=\"formComercialAgent\" (change)=\"onChangeForm()\">\n  <div class=\"details\">\n    <ion-row>\n      <ion-col size=\"12\">\n        <div class=\"detail-item\">\n          <ion-item>\n            <ion-input (change)=\"$event.target.value = $event.target.value.toUpperCase()\"\n              formControlName=\"nameAgent\"\n              type=\"text\"\n              class=\"nameAgent\"\n              placeholder=\"{{ 'ONBORDING.COMERCIAL_AGENT.FORM.NAME_AGENT.PLACEHOLDER' | wlpTranslate }}\"\n              maxlength=\"100\"\n            >\n            </ion-input>\n          </ion-item>\n\n          <div class=\"error-messages\">\n            <ng-container *ngFor=\"let error of errorMessages.nameAgent\">\n              <div\n                class=\"error-message\"\n                *ngIf=\"\n                  formComercialAgent.get('nameAgent').hasError(error.type) &&\n                  (formComercialAgent.get('nameAgent').dirty || formComercialAgent.get('nameAgent').touched)\n                \"\n              >\n                {{ error.message | wlpTranslate }}\n              </div>\n            </ng-container>\n          </div>\n        </div>\n      </ion-col>\n\n      <ion-col size=\"12\">\n        <div class=\"detail-item\">\n          <ion-item>\n            <ion-input \n              (change)=\"$event.target.value = $event.target.value.toUpperCase()\"\n              (keyup)=\"cpfAgent=format(cpfAgent)\"\n              name=\"cpfAgent\"\n              [(ngModel)]=\"cpfAgent\"\n              formControlName=\"cpfAgent\"\n              maxlength=\"18\"\n              ngModel\n              class=\"cpfAgent\"\n              placeholder=\"{{ 'ONBORDING.COMERCIAL_AGENT.FORM.CPF_AGENT.PLACEHOLDER' | wlpTranslate }}\"\n            >\n            </ion-input>\n          </ion-item>\n\n          <div class=\"error-messages\">\n            <ng-container *ngFor=\"let error of errorMessages.cpfAgent\">\n              <div\n                class=\"error-message\"\n                *ngIf=\"\n                  formComercialAgent.get('cpfAgent').hasError(error.type) &&\n                  (formComercialAgent.get('cpfAgent').dirty || formComercialAgent.get('cpfAgent').touched)\n                \"\n              >\n                {{ error.message | wlpTranslate }}\n              </div>\n            </ng-container>\n          </div> \n        </div>\n      </ion-col>\n    </ion-row>\n  </div>\n</form>\n",
        styles: [""]
    })
], UiCComercialAgentComponent);

let UiCComercialAgentModule = class UiCComercialAgentModule {
};
UiCComercialAgentModule = __decorate([
    NgModule({
        declarations: [UiCComercialAgentComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            IonicModule,
            UiBsTranslateModule
        ],
        exports: [UiCComercialAgentComponent]
    })
], UiCComercialAgentModule);

/*
 * Public API Surface of ui-c-comercial-agent
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCComercialAgentComponent, UiCComercialAgentModule };
//# sourceMappingURL=wlp-ui-c-comercial-agent.js.map
